import CarrierEnum from 'common/src/code/data/carriers/Carrier.enum';

// Check if business rule for rendering tracking name applies to this carrier.
export const isCarrierTrackingSpecialCase = ({
	deliveryConfirmationAmount,
	carrier,
}) =>
	!!(
		deliveryConfirmationAmount === 0 &&
		(carrier === CarrierEnum.USPS ||
			carrier === CarrierEnum.UPS ||
			carrier === CarrierEnum.DHLExpress ||
			carrier === CarrierEnum.FedEx)
	);

/**
 * Changes tracking name to adhere business rule for certain carriers.
 * This behavior was migrated from EXT.
 */
export const carrierTrackingName = ({
	carrier,
	carrierName,
	deliveryConfirmationAmount,
}) =>
	isCarrierTrackingSpecialCase({ deliveryConfirmationAmount, carrier })
		? `${carrierName} Tracking`
		: false;
